import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../core/auth.service';

export const isAdminLoginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const { role } = authService.getAccessTokenInfo();
  if (role === 'admin') {
    return true;
  } else {
    router.navigateByUrl('/');
    return false;
  }
};

/** @deprecated Use the functional `isAdminLoginGuard` instead */
export { isAdminLoginGuard as IsAdminLoginGuard };
